import { ApiPostCreatedResponse } from './helpers'
import { httpClient } from './http-client'

export function getRenewedToken() {
  return httpClient.post<ApiPostCreatedResponse<'/tokens/renew'>>(
    `/tokens/renew`
  )
}
